const style = (theme) => {
  const output = {
    root: {
      minHeight: '100vh',
      background: theme.colors[4],
      color: theme.colors[1],
      paddingTop: (props) => props.headerHeight,
    },
    wrapper: {
      extend: theme.wrapper,
    },
    description: {
      marginTop: 75,
    },
    insurance: {
      marginTop: 120,
      marginBottom: 120,
    },
    insuranceGrid: {
      justifyContent: 'center',
    },
    textWrapper: {
      marginTop: 120,
      '& $text': {
        width: '60%',
        margin: '0 auto',
      },
    },
    text: {},
    warranty: {
      marginTop: 120,
    },
    warrantyList: {
      display: 'flex',
      flexWrap: 'wrap',
      listStyleType: 'none',
      alignItems: 'stretch',
      counterReset: 'my-counter',
      padding: 0,
      '& li': {
        hypens: 'auto',
        fontSize: 25,
        flexBasis: '50%',
        maxWidth: '50%',
        counterIncrement: 'my-counter',
        position: 'relative',
        padding: '0 6% 50px 70px',
        '&::before': {
          content: 'counter(my-counter,decimal-leading-zero) " "',
          position: 'absolute',
          top: 10,
          left: 0,
          fontSize: 12,
          textAlign: 'center',
          lineHeight: '24px',
          borderRadius: '50%',
          width: 28,
          height: 28,
          border: `1px solid ${theme.colors[1]}`,
        },
      },
    },
    warrantyListText: {
      fontSize: 15,
      marginTop: 30,
    },
    imageWrapper: {
      marginTop: 50,
      position: 'relative',
      zIndex: 1,
      overflow: 'hidden',
      borderRadius: 16,
      width: '100%',
      '&::before': {
        content: '""',
        zIndex: 1,
        display: 'block',
        top: 0,
        left: 0,
        width: '100%',
        paddingBottom: '45%',
      },
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
    textWrapper: {
      marginTop: 60,
      '& $text': {
        width: '80%',
      },
    },
    text: {},
    warranty: {
      marginTop: 100,
    },
    insurance: {
      marginTop: 60,
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    textWrapper: {
      '& $text': {
        width: '100%',
      },
    },
    text: {},
    warrantyList: {
      '& li': {
        fontSize: 16,
        flexBasis: '100%',
        maxWidth: '100%',
      },
    },
  }

  return output
}

export default style
